import { ScriptDef, ScriptTheme } from '../../types';

/**
 * 综艺剧本（2026-10-30 导码，来源 = docs/剧本/综艺.md 十版；台账 §3/§4/§5 规则派生）。
 * 门槛值按 §3 速查表（角色卡 ｜试镜 属性序=主属性序），成长按 §4，拍摄周期按 §5 variety 行 4/2/2/1/1。
 * 交付口径（玩法设计.md §综艺）：常驻综艺=邀约制⛔ 不入试镜市场池（月掷递约接线在后续批）；
 * 版本七学员位 Lv.1=低咖位试镜口子的载体（待排期入池）。排期未接入前全部不在市场出现。
 * 角色无姓名（综艺称谓即定位，ScriptRoleDef.name 可空口径）。
 */
export const VARIETY_SCRIPTS: ScriptDef[] = [
    {
        id: 'SCRIPT_163',
        name: '《灯灭之后》',
        genre: 'variety',
        synopsis: '六位常驻住进一座整体迁建的清代老宅，每晚灯灭之后宅中发生一桩"悬案"，破案线索藏在梁上、灶下与旧物里，破不了案就集体去睡柴房。节目把文物修缮的考据劲头用在谜题上：每一件道具都有出处，每一个机关都对应一段宅史。',
        roles: [
            {
                roleType: '常驻MC',
                billing: 1,
                intro: '控场型艺人。全程脱稿，要接得住梗也压得住场，最好有长青综艺或深度访谈履历；节目组明确不要"照着提词器念"型。',
                level: 8,
                gender: 'any',
                requirements: [{ attr: 'eq', value: 80 }, { attr: 'talent', value: 70 }, { attr: 'temperament', value: 65 }, { attr: 'charm', value: 55 }],
                shootWeeks: 4,
                attributeGrowth: { eq: 4, talent: 3, temperament: 3, charm: 3 },
            },
            {
                roleType: '常驻嘉宾',
                billing: 2,
                intro: '逻辑型艺人，话不多但句句有信息量。话剧、悬疑剧出身优先——节目看重"进宅先看房梁"式的观察本能。',
                level: 7,
                gender: 'any',
                requirements: [{ attr: 'wisdom', value: 60 }, { attr: 'eq', value: 55 }, { attr: 'talent', value: 50 }, { attr: 'artistry', value: 40 }],
                shootWeeks: 2,
                attributeGrowth: { wisdom: 3, eq: 3, talent: 2, artistry: 2 },
            },
            {
                roleType: '常驻嘉宾',
                billing: 3,
                intro: '综艺感核心位，专管全员卡壳时救场。要自嘲功力也要反应速度，"敢"比咖位重要。',
                level: 6,
                gender: 'any',
                requirements: [{ attr: 'eq', value: 50 }, { attr: 'talent', value: 45 }, { attr: 'temperament', value: 40 }],
                shootWeeks: 2,
                attributeGrowth: { eq: 3, talent: 3, temperament: 2 },
            },
            {
                roleType: '常驻嘉宾',
                billing: 4,
                intro: '成长型新人，胆子小没关系，节目要的就是从怕到敢的全过程；有推理爱好或复盘强迫症者优先。',
                level: 5,
                gender: 'any',
                requirements: [{ attr: 'talent', value: 40 }, { attr: 'wisdom', value: 35 }, { attr: 'charm', value: 30 }],
                shootWeeks: 1,
                attributeGrowth: { talent: 2, wisdom: 2, charm: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Mystery, ScriptTheme.Performance, ScriptTheme.Culture],
        baseScore: 8.6,
        heat: 42,
    },
    {
        id: 'SCRIPT_164',
        name: '《婚礼彩排》',
        genre: 'variety',
        synopsis: '三对决定离婚的夫妻接受节目委托：用二十一天亲手替素人新人策划一场婚礼。写誓词、订菜单、彩排入场，每一步都在照见自己的婚姻；观察室同步解读，不下判断，只拆过程。',
        roles: [
            {
                roleType: '观察室主持',
                billing: 1,
                intro: '情感内容阅历深厚的写作者或主持人，提问敢往深里走，不下台阶也不递台阶。',
                level: 8,
                gender: 'any',
                requirements: [{ attr: 'eq', value: 80 }, { attr: 'talent', value: 70 }, { attr: 'wisdom', value: 65 }, { attr: 'temperament', value: 55 }],
                shootWeeks: 4,
                attributeGrowth: { eq: 4, talent: 3, wisdom: 3, temperament: 3 },
            },
            {
                roleType: '常驻嘉宾',
                billing: 2,
                intro: '真从业者优先，办过足够多的婚礼、见过足够多的散场；本人婚姻状况不设限，但对"经营关系"要有话可说。',
                level: 7,
                gender: 'any',
                requirements: [{ attr: 'eq', value: 60 }, { attr: 'talent', value: 55 }, { attr: 'temperament', value: 50 }, { attr: 'wisdom', value: 40 }],
                shootWeeks: 2,
                attributeGrowth: { eq: 3, talent: 3, temperament: 2, wisdom: 2 },
            },
            {
                roleType: '常驻嘉宾',
                billing: 3,
                intro: '需要婚姻阅历和扎实的口条，脾气要好、立场要稳，金句要能落进生活里。',
                level: 6,
                gender: 'any',
                requirements: [{ attr: 'eq', value: 50 }, { attr: 'talent', value: 45 }, { attr: 'temperament', value: 40 }],
                shootWeeks: 2,
                attributeGrowth: { eq: 3, talent: 3, temperament: 2 },
            },
            {
                roleType: '常驻嘉宾',
                billing: 4,
                intro: '幕后岗位前移，要镜头感和共情力兼备的年轻创作者；社恐慎入，这档节目镜头不躲人。',
                level: 5,
                gender: 'any',
                requirements: [{ attr: 'eq', value: 40 }, { attr: 'temperament', value: 35 }, { attr: 'talent', value: 30 }],
                shootWeeks: 1,
                attributeGrowth: { eq: 2, temperament: 2, talent: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Romance, ScriptTheme.LifeStyle],
        baseScore: 8.4,
        heat: 46,
    },
    {
        id: 'SCRIPT_165',
        name: '《爪印门诊》',
        genre: 'variety',
        synopsis: '八位素人兽医实习生进入一家老牌动物医院，完成为期三个月的轮岗实习；观察室由主持人和带教院长坐镇，边看边译。犬猫异宠轮着来，夜诊、急诊、临终关怀一样不落——这是国内首档把动物医院拍成主场景的职场观察真人秀。',
        roles: [
            {
                roleType: '观察室主持',
                billing: 1,
                intro: '养宠艺人优先，能把专业术语翻译成人话、翻译错了敢当场认；怕动物血者慎投。',
                level: 7,
                gender: 'any',
                requirements: [{ attr: 'eq', value: 60 }, { attr: 'talent', value: 55 }, { attr: 'temperament', value: 50 }, { attr: 'wisdom', value: 40 }],
                shootWeeks: 4,
                attributeGrowth: { eq: 3, talent: 3, temperament: 2, wisdom: 2 },
            },
            {
                roleType: '常驻嘉宾',
                billing: 2,
                intro: '真兽医或长期投身动物公益的艺人，压得住诊室、讲得出病例；镜头前不许装。',
                level: 6,
                gender: 'any',
                requirements: [{ attr: 'temperament', value: 50 }, { attr: 'wisdom', value: 45 }, { attr: 'eq', value: 40 }],
                shootWeeks: 2,
                attributeGrowth: { temperament: 3, wisdom: 3, eq: 2 },
            },
            {
                roleType: '常驻嘉宾',
                billing: 3,
                intro: '跟诊沉浸式实习的艺人，一周轮一个岗，从扫猫砂到进手术室观摩都要上手；怕动物血者勿扰。',
                level: 5,
                gender: 'any',
                requirements: [{ attr: 'talent', value: 40 }, { attr: 'eq', value: 35 }, { attr: 'stamina', value: 30 }],
                shootWeeks: 2,
                attributeGrowth: { talent: 2, eq: 2, stamina: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.LifeStyle, ScriptTheme.Occupation],
        baseScore: 7.9,
        heat: 40,
    },
    {
        id: 'SCRIPT_166',
        name: '《守艺人》',
        genre: 'variety',
        synopsis: '九项濒危非遗，每期一位明星"守护人"进山拜师，学艺一个月后把技艺的前世今生搬上舞台，每期十分钟不打光、不配乐，镜头只对准匠人的手。宗旨为"只拍手"。',
        roles: [
            {
                roleType: '发起人',
                billing: 1,
                intro: '纪录片或文化节目背景，能跟平台拍桌子保住"只拍手"十分钟的人；对非遗要有敬畏，不许当猎奇噱头拍。',
                level: 8,
                gender: 'any',
                requirements: [{ attr: 'temperament', value: 80 }, { attr: 'wisdom', value: 70 }, { attr: 'eq', value: 65 }, { attr: 'talent', value: 55 }],
                shootWeeks: 4,
                attributeGrowth: { temperament: 4, wisdom: 3, eq: 3, talent: 3 },
            },
            {
                roleType: '常驻嘉宾',
                billing: 2,
                intro: '非遗世家或师承清晰的真匠人，手上有绝活、嘴上有分量，敢骂明星也敢教明星。',
                level: 7,
                gender: 'any',
                requirements: [{ attr: 'temperament', value: 60 }, { attr: 'wisdom', value: 55 }, { attr: 'eq', value: 50 }, { attr: 'artistry', value: 40 }],
                shootWeeks: 2,
                attributeGrowth: { temperament: 3, wisdom: 3, eq: 2, artistry: 2 },
            },
            {
                roleType: '常驻嘉宾',
                billing: 3,
                intro: '话剧影视演员，肯真学真练，一个多月下来手上要磨得出茧；镜头前的"像"必须是练出来的。',
                level: 6,
                gender: 'any',
                requirements: [{ attr: 'talent', value: 50 }, { attr: 'stamina', value: 45 }, { attr: 'temperament', value: 40 }],
                shootWeeks: 2,
                attributeGrowth: { talent: 3, stamina: 3, temperament: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Culture, ScriptTheme.Performance, ScriptTheme.LifeStyle],
        baseScore: 9.0,
        heat: 41,
    },
    {
        id: 'SCRIPT_167',
        name: '《一抖惊人》',
        genre: 'variety',
        synopsis: '四十八位素人喜剧新人封闭十周，在两位导师带领下打磨一个属于自己的喜剧小专场。结课即公演，公演不设彩排：哪个包袱抖哑了，就当场重来，观众笑出声才算过——这群素人的舞台首秀，从第一声笑开始。',
        roles: [
            {
                roleType: '组委会会长',
                billing: 1,
                intro: '说书人、主持人或喜剧节操盘手皆可，点评只留"过、不过、再来一遍"三种答案；和稀泥型勿扰。',
                level: 8,
                gender: 'any',
                requirements: [{ attr: 'talent', value: 80 }, { attr: 'temperament', value: 70 }, { attr: 'wisdom', value: 65 }, { attr: 'eq', value: 55 }],
                shootWeeks: 4,
                attributeGrowth: { talent: 4, temperament: 3, wisdom: 3, eq: 3 },
            },
            {
                roleType: '喜剧导师',
                billing: 2,
                intro: '开麦多年的喜剧演员或剧场老板，选人看人不看梗，还得扛得住选手背后骂。',
                level: 7,
                gender: 'any',
                requirements: [{ attr: 'talent', value: 60 }, { attr: 'eq', value: 55 }, { attr: 'temperament', value: 50 }, { attr: 'wisdom', value: 40 }],
                shootWeeks: 2,
                attributeGrowth: { talent: 3, eq: 3, temperament: 2, wisdom: 2 },
            },
            {
                roleType: '喜剧导师',
                billing: 3,
                intro: '头部喜剧编剧，毙稿要狠、理由要细，让选手交稿前愿意排队求你看。',
                level: 6,
                gender: 'any',
                requirements: [{ attr: 'wisdom', value: 50 }, { attr: 'talent', value: 45 }, { attr: 'eq', value: 40 }],
                shootWeeks: 2,
                attributeGrowth: { wisdom: 3, talent: 3, eq: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Comedy, ScriptTheme.Performance, ScriptTheme.LifeStyle],
        baseScore: 8.1,
        heat: 42,
    },
    {
        id: 'SCRIPT_168',
        name: '《主角预备役》',
        genre: 'variety',
        synopsis: '二十位新人演员进入"主角预备役"训练营，历经小品汇报、镜头考核、剧组实习三轮淘汰，最终一人签约大制作女主角位。节目号称全真实记录，镜头里处处是名场面：深夜加练、导师落泪、学员抱头痛哭，以及一段每期必被预告的"惊天冲突"。',
        roles: [
            {
                roleType: '训练营校长',
                billing: 1,
                intro: '学院派表演教授，业界公认教得好也骂得狠，点评要有压场的分量与"人间清醒"。',
                level: 6,
                gender: 'any',
                requirements: [{ attr: 'talent', value: 50 }, { attr: 'temperament', value: 45 }, { attr: 'wisdom', value: 40 }],
                shootWeeks: 4,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2 },
            },
            {
                roleType: '表演导师',
                billing: 2,
                intro: '有代表作的实力演员，语速慢、气场稳，点评以专业为准绳；剪辑组欢迎"留白型"嘉宾。',
                level: 5,
                gender: 'any',
                requirements: [{ attr: 'talent', value: 40 }, { attr: 'temperament', value: 35 }, { attr: 'wisdom', value: 30 }],
                shootWeeks: 2,
                attributeGrowth: { talent: 2, temperament: 2, wisdom: 2 },
            },
            {
                roleType: '经纪人观察员',
                billing: 3,
                intro: '一线经纪人，敢谈市场也敢谈流量，观点越鲜明越好，吵起来不怕。',
                level: 5,
                gender: 'any',
                requirements: [{ attr: 'eq', value: 40 }, { attr: 'talent', value: 35 }, { attr: 'temperament', value: 30 }],
                shootWeeks: 2,
                attributeGrowth: { eq: 2, talent: 2, temperament: 2 },
            },
            {
                roleType: '素人学员',
                billing: 4,
                intro: '艺考名校在读或应届，基本功扎实、情绪饱满；镜头缘好者优先。',
                level: 1,
                gender: 'any',
                requirements: [{ attr: 'talent', value: 5 }, { attr: 'charm', value: 5 }],
                shootWeeks: 1,
                attributeGrowth: { talent: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Performance],
        baseScore: 5.6,
        heat: 28,
    },
    {
        id: 'SCRIPT_169',
        name: '《安可》',
        genre: 'variety',
        synopsis: '十六支乐队进驻旧厂房改建的 Livehouse，老牌乐队与新乐队每轮配对、互编对方的歌。现场观众实名投出歌单排名，垫底一轮淘汰一支，不设复活。每期由一位艺人嘉宾与当期乐队共同完成一首改编曲的表演，没有赛制任务也没有命题考试，只有台上合完一遍才知道能不能成。',
        roles: [
            {
                roleType: '常驻MC',
                billing: 1,
                intro: '音乐综艺主持出身，接得住乐队的散话、不抢歌的风头，报名次要稳。',
                level: 8,
                gender: 'any',
                requirements: [{ attr: 'eq', value: 80 }, { attr: 'talent', value: 70 }, { attr: 'temperament', value: 65 }, { attr: 'charm', value: 55 }],
                shootWeeks: 4,
                attributeGrowth: { eq: 4, talent: 3, temperament: 3, charm: 3 },
            },
            {
                roleType: '飞行主宾',
                billing: 2,
                intro: '唱演两栖艺人，每期与一支乐队合排一首改编曲；上台前的排练过程比舞台呈现更有看头。',
                level: 7,
                gender: 'any',
                requirements: [{ attr: 'artistry', value: 60 }, { attr: 'talent', value: 55 }, { attr: 'eq', value: 50 }, { attr: 'wisdom', value: 40 }],
                shootWeeks: 2,
                attributeGrowth: { artistry: 3, talent: 3, eq: 2, wisdom: 2 },
            },
            {
                roleType: '飞行嘉宾',
                billing: 3,
                intro: '坐在观众席的艺人嘉宾，给的是普通听众的真实反应，不装感动不端架子，点评认歌也认人。',
                level: 6,
                gender: 'any',
                requirements: [{ attr: 'eq', value: 50 }, { attr: 'talent', value: 45 }, { attr: 'temperament', value: 40 }],
                shootWeeks: 2,
                attributeGrowth: { eq: 3, talent: 3, temperament: 2 },
            },
            {
                roleType: '常驻嘉宾',
                billing: 4,
                intro: '后台访谈主持，能让闷头弹贝斯的开腔说人话；台上冲突不许由采访位起哄。',
                level: 5,
                gender: 'any',
                requirements: [{ attr: 'eq', value: 40 }, { attr: 'talent', value: 35 }, { attr: 'temperament', value: 30 }],
                shootWeeks: 1,
                attributeGrowth: { eq: 2, talent: 2, temperament: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Music, ScriptTheme.Performance],
        baseScore: 8.3,
        heat: 42,
    },
    {
        id: 'SCRIPT_170',
        name: '《周末openmic》',
        genre: 'variety',
        synopsis: '周六晚黄金档的游戏综艺，固定 MC 三人撑场十二季，每期迎一组飞行嘉宾玩游戏、聊近况、顺势宣传新作品——业内公认的"新戏第一宣发站"。',
        roles: [
            {
                roleType: '飞行嘉宾',
                billing: 1,
                intro: '带作品来的宣传嘉宾，要接得住游戏环节也递得出作品话题；社恐但真诚的也欢迎，节目会剪出反差萌。',
                level: 5,
                gender: 'female',
                requirements: [{ attr: 'eq', value: 40 }, { attr: 'charm', value: 35 }, { attr: 'talent', value: 30 }],
                shootWeeks: 4,
                attributeGrowth: { eq: 2, charm: 2, talent: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Comedy, ScriptTheme.Performance],
        baseScore: 6.8,
        heat: 36,
    },
    {
        id: 'SCRIPT_171',
        name: '《大驾光临》',
        genre: 'variety',
        synopsis: '棚内访谈+游戏的老牌周播综艺，主持阵容十年未变，每期一位主宾带着新作品来坐镇，聊作品也聊人生，圈内外口碑都稳。',
        roles: [
            {
                roleType: '飞行嘉宾',
                billing: 1,
                intro: '带新作品上节目宣传的主宾，访谈要敢聊、游戏要放得开；口碑期或争议期都欢迎，节目不怕话题。',
                level: 6,
                gender: 'female',
                requirements: [{ attr: 'eq', value: 50 }, { attr: 'talent', value: 45 }, { attr: 'temperament', value: 40 }],
                shootWeeks: 4,
                attributeGrowth: { eq: 3, talent: 3, temperament: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.LifeStyle, ScriptTheme.Occupation],
        baseScore: 7.2,
        heat: 36,
    },
    {
        id: 'SCRIPT_172',
        name: '《星动之夜》',
        genre: 'variety',
        synopsis: '季度大事件级别的舞台竞演特辑，固定主持团+每期重磅飞行嘉宾的舞台表演，灯光舞美拉满，是高咖位艺人宣发新作的排面之选。',
        roles: [
            {
                roleType: '飞行嘉宾',
                billing: 1,
                intro: '带重磅作品登台的高咖位嘉宾，一段舞台一个开场白都要有排面；节目组配顶级舞团与灯光团队。',
                level: 7,
                gender: 'female',
                requirements: [{ attr: 'talent', value: 60 }, { attr: 'temperament', value: 55 }, { attr: 'charm', value: 50 }, { attr: 'artistry', value: 40 }],
                shootWeeks: 4,
                attributeGrowth: { talent: 3, temperament: 3, charm: 2, artistry: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Idol, ScriptTheme.Performance],
        baseScore: 7.8,
        heat: 45,
    },
    {
        id: 'SCRIPT_174',
        name: '《追更营业中》',
        genre: 'variety',
        synopsis: '视频平台的剧综联动轻量档，网剧开播前请主创进棚，追更团带着弹幕热评现场提问，玩梗、拆片花、连麦书粉——小成本快节奏，直接对着平台观众做转化。',
        roles: [
            {
                roleType: '追更嘉宾位',
                billing: 1,
                intro: '带新剧来和追更团见面的网剧主创，接得住弹幕热梗、聊得起角色结局；平台观众认人，这期聊嗨了剧就多一层自来水。',
                level: 5,
                gender: 'female',
                requirements: [{ attr: 'eq', value: 45 }, { attr: 'charm', value: 40 }, { attr: 'talent', value: 35 }],
                shootWeeks: 4,
                attributeGrowth: { eq: 2, charm: 2, talent: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Comedy, ScriptTheme.LifeStyle],
        baseScore: 6.4,
        heat: 34,
    },
];
